/// <amd-module name="Artifacts/Feed/services/PackageListService" />
import * as Constants from "Artifacts/Root/Constants";
import { loadNonNullData } from "Artifacts/Root/helpers/DataProviderHelpers";
import { getFeedIdentifier } from "Artifacts/Root/helpers/FeedHelpers";
import { IFeed } from "Artifacts/Root/types";
import { PackageListDataItem, ViewIdentifier } from "Artifacts/Root/types/AzureArtifacts";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";

const defaultTop = 50;
const defaultSkip = 0;

export interface PackageListDataProviderParams {
  top?: number;
  skip?: number;
  isListed?: boolean;
  includeDescription?: boolean;
  packageName?: string;
  directUpstreamSourceId?: string;
}
export interface IPackageListService extends IVssService {
  getPackageList(
    context: IVssPageContext,
    feed: IFeed,
    view?: ViewIdentifier,
    params?: PackageListDataProviderParams,
  ): Promise<PackageListDataItem[]>;
}

export class PackageListService extends VssService implements IPackageListService {
  async getPackageList(
    context: IVssPageContext,
    feed: IFeed,
    view?: ViewIdentifier,
    params?: PackageListDataProviderParams,
  ): Promise<PackageListDataItem[]> {
    const top = params?.top ? params.top : defaultTop;
    const skip = params?.skip ? params.skip : defaultSkip;
    // isListed should be null for onprem and true for hosted until sproc improvments are made
    const isListed = params?.isListed !== undefined ? params.isListed : null;
    const packageNameQuery = params?.packageName !== undefined ? params.packageName : null;
    const includeDescription = params?.includeDescription ? params.includeDescription : true;
    const directUpstreamSourceId = params?.directUpstreamSourceId
      ? params.directUpstreamSourceId
      : null;

    const feedIdentifier = getFeedIdentifier(feed, view);

    const properties = {
      feedId: feedIdentifier,
      directUpstreamSourceId: directUpstreamSourceId,
      projectId: feed && feed.project ? feed.project.id : null,
      top: top,
      skip: skip,
      isListed: isListed,
      packageNameQuery: packageNameQuery,
      includeDescription: includeDescription,
    };

    const data = await loadNonNullData<PackageListDataItem[]>(
      context,
      "ms.azure-artifacts.package-list-data-provider",
      properties,
      false,
      Constants.CommonConstants.FeedServiceInstanceId,
    );

    return data;
  }
}

Services.add("IPackageListService", { serviceFactory: PackageListService });
